import React, { FC, ReactElement } from 'react';
import { CardComponentsProps } from './types';

const CardContent: FC<CardComponentsProps> = ({ children, className }): ReactElement => {
    return (
        <div className={className}>{children}</div>
    );
};

export { CardContent };